import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { Card, CardContent, CardHeader } from '@/components/ui/card';

/** Carte centrée des écrans d'authentification (login, MFA), sur fond dégradé violet → teal. */
export const AuthCard = ({
  icon: Icon,
  title,
  description,
  children,
  footer,
}: {
  icon: LucideIcon;
  title: string;
  description: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) => (
  <div className="relative flex flex-1 items-center justify-center overflow-hidden bg-gradient-to-br from-brand-violet via-brand-violet to-brand-teal p-4 sm:p-8">
    <div aria-hidden className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-white/5" />
    <div aria-hidden className="pointer-events-none absolute -bottom-32 -left-16 h-96 w-96 rounded-full bg-brand-teal/20" />
    <Card className="relative w-full max-w-md border-0 shadow-2xl">
      <CardHeader className="items-center space-y-3 pb-4 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-violet/10">
          <Icon className="h-6 w-6 text-brand-violet" aria-hidden />
        </span>
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        <p className="text-sm text-muted-foreground">{description}</p>
      </CardHeader>
      <CardContent>{children}</CardContent>
      {footer && <div className="border-t px-6 py-4 text-center text-xs text-muted-foreground">{footer}</div>}
    </Card>
  </div>
);
